let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("405ZQ")).then(() => parcelRequire('cH3Vk'));